import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 8,
    maxWidth: 900,
    width: '100%',
    position: 'absolute',
    top: '15vh',
    margin: 0,
    backgroundColor: ({ isDark }) => isDark ? '#1e1e1e' : '#ffffff',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
  inputBase: {
    padding: theme.spacing(2, 3),
    width: '100%',
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontSize: '1.3rem',
    color: "var(--mainText)",
  },
  list: {
    padding: theme.spacing(1),
    overflow: 'hidden',
  },
  listItem: {
    padding: '10px 18px',
    borderRadius: 6,
    marginBottom: 4,
    '&:hover': {
      backgroundColor: ({ isDark }) => isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
    },
    '&.Mui-selected': {
      backgroundColor: ({ isDark }) => isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
      '&:hover': {
        backgroundColor: ({ isDark }) => isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)',
      }
    }
  },
  listItemRow: {
    margin: 0,
    height: '100%',
    boxSizing: 'border-box',
    alignItems: 'flex-start',
  },
  listItemIcon: {
    minWidth: 36,
    display: 'flex',
    alignItems: 'center',
    marginTop: 2,
    '& svg': {
      width: '20px !important',
      height: '20px !important',
      fontSize: '20px !important',
      fill: ({ isDark }) => isDark ? 'rgba(255, 255, 255, 0.4) !important' : 'rgba(0, 0, 0, 0.3) !important',
      color: ({ isDark }) => isDark ? 'rgba(255, 255, 255, 0.4) !important' : 'rgba(0, 0, 0, 0.3) !important',
    }
  },
  listItemTextContainer: {
    marginTop: 0,
  },
  matchHighlight: {
    color: '#eab308',
    fontWeight: 'bold',
  },
  footer: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    fontSize: '1rem',
    color: 'var(--mainText) !important',
    backgroundColor: ({ isDark }) => isDark ? '#252525' : '#f9f9f9',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  keyHint: {
    backgroundColor: ({ isDark }) => isDark ? '#333333' : '#e0e0e0',
    color: ({ isDark }) => isDark ? '#ffffff' : '#000000',
    border: "1px solid var(--borderColor)",
    padding: '4px 8px',
    borderRadius: 4,
    fontWeight: 'bold',
    fontFamily: 'inherit',
    marginRight: 4,
    display: 'inline-block',
  }
}));

export default useStyles;
